module.exports = __webpack_public_path__ + "media/images/proof_links/colored/periscope-0b97d0ad4e749f92385296a3ca73fe6b.svg";